import React from "react";
import styled from "styled-components";
import colours from "../../lib/colours";
import IconControl from "../atoms/Icon";
import { ReactComponent as LocationTickIcon } from "../../assets/svg/locationTick.svg";
import { ReactComponent as PolygonSketchIcon } from "../../assets/svg/polygonSketch.svg";
import { ReactComponent as ReportIcon } from "../../assets/svg/report.svg";

const iconSources: Record<string, any> = {
  locationTick: LocationTickIcon,
  polygonSketch: PolygonSketchIcon,
  report: ReportIcon,
};

const iconStyles: Record<string, any> = {
  locationTick: { position: "relative", left: "2px" },
  polygonSketch: {},
  report: { position: "relative", left: "1px" },
};

const StageContainer = styled.button`
  display: flex;
  width: 100%;
  height: 60px;
  align-items: center;
  border: none;
  font-weight: 300;
  cursor: pointer;
  padding-inline: 10px;
  background-color: ${colours.th1l1};
  color: ${colours.white};

  &:disabled {
    color: ${colours.th1l3};
    cursor: not-allowed;
  }
`;

const StageContainerActive = styled(StageContainer)`
  background-color: ${colours.white};
  color: ${colours.th1};
  font-weight: 500;
`;

const TextContainer = styled.div`
  flex: 1;
  font-size: 16px;
  text-align: left;
  padding-inline: 10px;
`;

interface IProps {
  stageId: number;
  name: string;
  icon: string;
  active: boolean;
  disabled: boolean;
  dataPanelOpen: boolean;
  onActivate: any;
}

const NavStage = ({
  stageId,
  name,
  icon,
  active,
  disabled,
  dataPanelOpen,
  onActivate,
}: IProps) => {
  const IconElement = iconSources[icon];
  const Container =
    active && dataPanelOpen ? StageContainerActive : StageContainer;
  return (
    <Container onClick={() => onActivate(stageId)} disabled={disabled}>
      <IconElement style={iconStyles[icon]} />
      <TextContainer>{name}</TextContainer>
      <IconControl icon="chevron-right" style={{}} />
    </Container>
  );
};

export default NavStage;
